<template>
  <div>
    <loading v-if="loading"/>
    <div v-else>
      <!--  header-->
      <TriangleHeader :title="single.topic[0].title"
                      :description="shortDesc"
      />
      <!--  title-->
<v-row  justify="center" align-content="start">
  <v-col class="mt-16" cols="12" md="1" xl="1" lg="1" align-self="start">
    
  </v-col>
  <v-col cols="12" md="10" xl="10" lg="10">
    <div

        v-html="single.topic[0].details"
        dir="auto"
        style=""
        class="mx-auto my-16 post-content"
    >
    </div>
  </v-col>
  <v-col class="mt-16" cols="12" md="1" xl="1" lg="1" align-self="start">
    
  </v-col>
</v-row>
  <div class="comment-section container">
    <h4>{{ $t('User Comments') }}</h4>
    <hr>
    <div class="comments-list mt-3" v-if="topic_comments && topic_comments.comments">
      <div  class="comment-item my-3" v-for="comment in topic_comments.comments" :key="comment.id">
        
        <div style="display: flex;align-items: center;">
          <v-avatar color="indigo">
          <v-icon dark>
            mdi-account-circle
          </v-icon>
        </v-avatar>
        <div>
          <span class="mr-3">{{comment.name}}</span>
        <p class="mr-3">{{comment.comment}}</p>
        </div>
        </div>
        
      </div>
      
    </div>
    <div class="comment-form mt-4">
      <ul style="margin-right:1.3rem;margin-bottom:1rem" v-if="isError">
        <li v-for="(error,key) in errors" :key="key">
          {{error[0]}}
        </li>
      </ul>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="3"
        >
        <label for="">{{$t('your-name')}} <span style="color:red">*</span></label>
          <v-text-field
          :rules="[rules.required]"
            outlined
            v-model="commentForm.comment_name"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="3"
        >
        <label for="">{{ $t('your-email') }} </label>
          <v-text-field
            type="email"
            :rules="[rules.required, rules.email]"
            outlined
            v-model="commentForm.comment_email"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="3"
        >
        <label for="">{{ $t('your-rating') }} </label>
        <v-rating
      
      background-color="orange lighten-3"
      color="orange"
      large
      v-model="commentForm.comment_rating"
    ></v-rating>
        </v-col>
    
      </v-row>
  
      <div class="form-group">
        <label for="">{{ $t('your-comment') }} <span style="color:red">*</span></label>
        <v-textarea
          name="input-7-1"
          :rules="[rules.required]"
          v-model="commentForm.comment_message"
          outlined
          class="mt-1"
        ></v-textarea>
      </div>
      <v-btn
      :loading="btnLoading"
      depressed
      @click="sendComment"
      color="primary"
    >
    {{ $t('submit') }}
    </v-btn>
      
    </div>
  </div>
    </div>
    <v-snackbar
        :value="isSuccess"
        color="warning"
    >
      <p dir="auto" class="snackbar-text">{{ $t('comment-sent') }}</p>
    </v-snackbar>
    <v-snackbar
        :value="isError"
        color="warning"
    >
      <p dir="auto" class="snackbar-text">{{ $t('error-occurred') }}</p>
    </v-snackbar>
  </div>
  
</template>

<script>
import TriangleHeader from "../../components/triangle_header/TriangleHeader";
import {GET_SINGLE} from "../../store/eventManagement/action_types";
import {mapState} from "vuex";

export default {
  name: "single",
  data(){
    return {
      commentForm:{
        comment_message:"",
        comment_name:"",
        comment_email:"",
        topic_id:"",

        api_key:"402784613679330"
      },
      btnLoading:false,
      isSuccess:false,
      errors:{},
        isError:false,
        rules: {
          required: value => !!value || 'الزامی.',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'ایمیل نامعتبر.'
          },
        },
    }
  },
  metaInfo() {
        return { 
            title: this.single && this.single.topic ? "اردکان - "+this.single.topic[0].title:"اردکان",
            meta: [
                { name: 'description', content:  (this.single && this.single.topic ? this.single.topic[0][`seo_description_${this.lang}`]:"")},
                { property: 'keywords', content: (this.single && this.single.topic ? this.single.topic[0][`seo_keywords_${this.lang}`]:"")}
            ]
        }
    },
  components: {TriangleHeader},
  created() {
    this.$store.dispatch(`eventManagement/${GET_SINGLE}`, {
      id: this.$route.params.id == null ? 22 : this.$route.params.id
    });
    this.$store.dispatch('eventManagement/getTopicComments',this.$route.params.id);
    this.commentForm.topic_id=this.$route.params.id;
  },
  computed: {
    ...mapState({
      single: state => state.eventManagement.single,
      loading: state => state.eventManagement.loading,
      topic_comments: state => state.eventManagement.topic_comments,
    }),
    lang(){
      return localStorage.getItem("lang")
    },
    shortDesc(){
      if(this.lang == "en"){
        if(this.single.topic[0].fields_count>0 && this.single.topic[0].fields[1]) return this.single.topic[0].fields[1].value;
        return "";
      }else if(this.lang == "ar"){
        if(this.single.topic[0].fields_count>0 && this.single.topic[0].fields[2]) return this.single.topic[0].fields[2].value;
        return "";
      }else{
        if(this.single.topic[0].fields_count>0 && this.single.topic[0].fields[0]) return this.single.topic[0].fields[0].value;
        return "";
      }
      
    }
  },
  methods:{
    sendComment(){
      
      
      if(!this.commentForm.comment_email) {
        alert(this.$t('please-enter-email'))
        return;
      }
      if(!this.commentForm.comment_name) {
        alert(this.$t('please-enter-name'))
        return;
      }
      if(!this.commentForm.comment_message) {
        alert(this.$t('Please enter message'))
        return;
      }
      this.isError=false
      this.btnLoading=true
      this.$store.dispatch('eventManagement/sendTopicComment',this.commentForm)
      .then(res=>{
        this.btnLoading=false
        this.commentForm={
        comment_message:"",
        comment_name:"",
        comment_email:"",
        topic_id:this.$route.params.id,
        api_key:"402784613679330"
      }
        console.log(res)
        this.isSuccess=true
        
      }).catch(e=>{
        console.log(e.response)
        this.btnLoading=false
        if(e.response && e.response.status == 422){
          this.isError=true;
          this.errors=e.response.data.errors
        }
      });
    }
  }
}
</script>
<style>
.post-content img{
  max-width: 100% !important;
}</style>
<style scoped>
h6 {
  text-align: right;
}

h4 {
  margin: 16px 0;
  font-weight: bold;
  text-align: right;
}

.faq-header {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 200px;
  background: #f2c303 url("../../assets/images/sunburst.png");
}

.faq-header-bottom-border {
  position: absolute;
  bottom: -22px;
  width: 100%;
}
.comment-item{
  border: 1px solid #857272;
  padding: 1rem;
  border-radius: 10px;
}

</style>